$(document).ready(function() {
    let faqEl = $(".faq-split-image");

    if(faqEl.length > 0) {
        init(faqEl);
    }

    function init(el) {
        var faqItems = $(el).find(".faq-container__item__question");
        // var faqImages = $(el).find(".faq-image");

        // Show first item as open
        $(faqEl).each(function() {
            showFaqItem(0, $(this));
        });

        // Event Listener
        $(faqItems).on("click", function() {
            var currentEl = $(this).closest(".faq-split-image");
            var itemID = parseInt($(this).parent(".faq-container__item").data("index"));
            showFaqItem(itemID, currentEl);
        });
    }

    function hideFaqItems(el, keepImage) {
        // var faqItems = $(el).find(".faq-container__item").removeClass("faq-visible");

        // Hide content
        $(el).find(".faq-container__item__answer").removeClass("in");
        $(el).find(".faq-container__item__answer").attr("aria-expanded","false");
        $(el).find(".faq-container__item").removeClass("faq-visible");

        // Update Icon
        $(el).find(".faq__icon").removeClass("faq__icon--open");

        // Hide image
        if(!keepImage) {
            $(el).find(".faq-image").removeClass("image-visible");
        }
    }

    function showFaqItem(id, el) {
        var elParent = $(el).closest(".faq-split-image");
        var content_area = $(el).find("[data-index='"+(id)+"']")[0];
        var image_area = $(el).find("[data-index='"+(id)+"']")[1];

        // Hide all items in instance

        console.log(content_area);
        if($(content_area).hasClass("faq-visible")){
            hideFaqItems(el, true);
            return;
        }

        hideFaqItems(el);

        // Content handled by aria
        $(content_area).find(".faq-container__item__answer").addClass("in");
        $(content_area).addClass("faq-visible");


        // Update icon
        $(content_area).find(".faq__icon").addClass("faq__icon--open");

        // Show image
        $(image_area).addClass("image-visible");
    }
});



// WEBPACK FOOTER //
// ./static/js/modules/accordion.js